<template>
    <div class="school-detail-container">
        <h4>{{ product.name }}</h4>
        <!-- <div v-if="product.videoLink" ref="videoRef"></div> -->
        <resourceVideoVue v-if="product.videoLink" :options="{source: product.videoLink, play: onPlay}" :title="pageTitle"></resourceVideoVue>
        <img v-else-if="product.signPoster" v-src="product.signPoster" width="100%" />
        <div class="content-wrapper" :class="{
            'content-wrapper-canSign': canSign
        }">
            <div class="desc">{{ product.desc }}</div>
            <template v-if="product.time">
                <div class="title">会议时间：</div>
                <div class="time">{{ product.time }}</div>
            </template>
            <template v-if="product.content">
                <div class="title">{{ contentTitle || '研讨会中您将看到' }}：</div>
                <div v-html="product.content" class="content"></div>
            </template>
            <template v-if="showNotes">
                <div class="title">讲义：</div>
                <ViewList class="content-list" @goToView="goToView" :dataSource="notes" nameKey="pdfName"
                    :showMail="item => item.pdfLink"></ViewList>
            </template>
            <template v-if="recommendList.length">
                <div class="title">推荐视频：</div>
                <div class="video-container">
                    <router-link v-for="item in recommendList" :key="item.id" class="video-item"
                        :to="{ name: 'schoolDetail', params: { hId: hId, rId: item.id } }">
                        <div class="video-wrapper">
                            <img :src="item.detail.poster" alt="" />
                            <img src="https://oss.cloud.custouch.com/res/95586/icon-playCircle.png" class="video-play">
                        </div>
                        <div class="name">{{ item.detail.name }}</div>
                    </router-link>
                </div>
            </template>
        </div>
        <div class="bottom-bar" @click="signUp(product)" v-if="canSign">
            <img src="@/assets/imgs/报名参会.png" /><span>{{
                    hasSigned ? '已成功报名' : '立即报名'
            }}</span>
        </div>
        <template v-if="signUpModal.inited">
            <SignUpModal :visible.sync="signUpModal.visible">
                <div class="sign-body">
                    <div class="hint">报名成功！</div>
                    <van-button type="primary" block="block" @click="asyncImportCom('signUpModal')">确定</van-button>
                </div>
            </SignUpModal>
        </template>
    </div>
</template>

<script>
import { SIGNUP_TYPE } from '@/configs/constants'
import asyncImportCom from '@/views/mixins/asyncImportCom'
import { UAID } from '@/configs/constants'
import { getActionRecords, addActionRecord } from '@/service/member'
import {
    getDataRow,
    getDataHierarchy,
    concatWithSymbol,
    getRecommendDataRows,
    getDataPaths
} from '@custouch/proxy-use'
// import { videoRender } from '@custouch/resource-video'

import dayjs from 'dayjs'
export default {
    mixins: [asyncImportCom],
    props: ['hId', 'rId', 'title'],
    data() {
        return {
            recommendList: [],
            product: {},
            signUpModal: {
                inited: false,
                visible: false
            },
            notes: [],
            canSign: false,
            isPlayed: false,
            overtime: false,
            loading: false,
            hasSigned: false,
            contentTitle: "",
            pageTitle: ''
        }
    },
    components: {
        SignUpModal: () => import('@/views/components/PopModal.vue'),
        ViewList: () => import('@/views/components/ViewList'),
        resourceVideoVue: () => import('@/views/components/resourceVideo.vue')
    },
    computed: {
        showNotes() {
            return !!(this.notes.length && this.overtime)
        }
    },
    methods: {
        onPlay(e) {
            if (!this.isPlayed) {
                const { duration, currentTime, source } = e.target
                this.isPlayed = true
                const info = {
                    uaId: 'byk_school_webinar_' + this.product.id,
                    event: e.type,
                    duration, //e.target.duration
                    currentTime, //e.target.currentTime
                    source
                }
                this.$root.$emit('actionview', {
                    info,
                    actionType: 'videoview'
                })
            }
        },
        goToView(item) {
            this.$router.push({
                name: 'pdfView',
                params: { hId: this.hId, rId: item.dataRowId }
            })
        },
        async checkSignStaus(item) {
            const list = await getActionRecords(1, 1, {
                types: [SIGNUP_TYPE],
                value: item.id
            })
            return list.total > 0
        },
        async signUp(item) {
            try {
                if (this.loading) return
                this.loading = true
                if (this.hasSigned) {
                    this.$message('您已报名，请勿重复报名')
                } else {
                    await this.add2Action(item)
                    this.hasSigned = true
                }
            } catch (error) {
                this.$message.fail(error.message)
            }

            this.loading = false
        },
        async add2Action(item) {
            await addActionRecord(SIGNUP_TYPE, item.name, {
                value: item.id
            })

            this.asyncImportCom('signUpModal')
            const info = {
                remark: `点击报名-${item.name}`,
                to: null
            }
            this.$root.$emit('actionview', {
                info,
                actionType: 'clickview'
            })
            this.$root.$emit('actionview', {
                info: Object.assign(
                    { uaId: UAID + '_webinar_signup_' + item.id },
                    info
                ),
                actionType: 'clickview'
            })
        },
        async mountVideo(title) {
            if (this.product.videoLink) {
                await this.$nextTick()
                // videoRender.render(this.$refs.videoRef, {
                //     source: this.product.videoLink,
                //     play: this.onPlay,
                //     // videoview/prevideoview 的事件参数
                //     viewParams: {
                //         title,
                //         uaId: UAID
                //     },
                // })
            }
        },
        async init() {
            if (this.$el) {
                this.$el.scrollTop = 0
            }
            const [product, hInfo, rList, [path]] = await Promise.all([
                getDataRow({ dataRowId: this.rId }),
                getDataHierarchy({ dataHierarchyId: this.hId }),
                getRecommendDataRows({ dataRowId: this.rId, dataTemplateId: window.env.CMS.template.video, size: 10, orderBy: 'createtime', desc: true }),
                getDataPaths({ dataRowId: this.rId, dataHierarchyId: this.hId })
            ])
            const mName = path?.dataHierarchy.name
            this.contentTitle = path?.dataHierarchy?.detail.contentTitle
            this.recommendList = rList
            this.product = { ...product.detail, tagIds: product.tagIds }
            this.notes = product.dataRows.map(t => ({
                ...t.detail,
                section: '讲义',
                dataHierarchy: this.hId,
                dataRowId: t.id
            }))
            const title = concatWithSymbol([
                this.title,
                mName,
                hInfo.name,
                this.product.name
            ])
            this.pageTitle = title
            this.$root.$emit('actionview', {
                info: {
                    title,
                    tagIds: this.product.tagIds
                },
                actionType: 'pageview'
            })
            // this.mountVideo(title)


            if (!this.product) return
            const { isVhall, endAt } = this.product
            if (endAt) {
                const time = dayjs(new Date(endAt))
                    .add(1, 'h')
                    .valueOf()
                const now = Date.now()
                this.overtime = now > time
                // 结束后无法报名
                this.canSign = isVhall && !this.overtime
                if (this.canSign) {
                    this.loading = true
                    this.hasSigned = await this.checkSignStaus(this.product)
                    this.loading = false
                }
            }
        }
    },
    watch: {
        rId: {
            handler() {
                this.init()
            },
            immediate: true
        }
    }
}
</script>
<style scoped lang="less">
@import '~@/assets/style/mixin.less';

.school-detail-container {
    padding: 1rem;
    font-size: 0.65rem;
    position: relative;
    padding-bottom: 3rem;

    video {
        width: 100%;
    }

    .content-wrapper {
        line-height: 1.1rem;
        color: #333333;
        &-canSign{
            padding-bottom: 2.7rem;
        }
    }
    .content{
        white-space: pre-line;
    }
    .desc {
        white-space: pre-line;
        color: @gray-6;
        margin: 0.8rem 0;
    }

    .title {
        color: #014ca0;
        font-size: 0.7rem;
        line-height: 1.8rem;
        background: #f8f8f8;
        padding-left: @padding-sm;
        margin: @padding-md 0;
    }
}

.bottom-bar {
    position: fixed;
    bottom: 4.45rem;
    left: 0;
    width: 100%;
    background: @blue;
    font-size: 0.8rem;
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: @padding-md 0;
    cursor: pointer;

    img {
        width: 0.7rem;
        margin-right: @padding-xs;
    }
}

.sign-body {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 1.6rem;
    font-size: 0.7rem;

    .hint {
        margin: 0.8rem 0 2rem;
    }
}

.video-container {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: auto;
    margin-bottom: 2rem;
    column-gap: .9rem;
    row-gap: .9rem;
    width: 100%;

}

.video-item {

    width: 8rem;
    flex-shrink: 0;

    .name {
        color: @themeColor;
    }

    .video-wrapper {
        position: relative;
    }

    img {
        width: 100%;
        object-fit: contain;
        height: 5rem;
    }

    p {
        color: #707173;
        margin-bottom: .7rem;
        .ellipsis(false);
    }

    .video-play {
        position: absolute;
        top: 50%;
        width: 1rem;
        object-fit: contain;
        left: 50%;
        transform: translate(-50%, -50%);
    }
}
</style>
